import { createContext, useContext } from 'react';
import type { StoreRole } from '@/entities/user';

export interface StoreContextValue {
  storeId: string;
  storeName: string;
  timezone: string;
  role: StoreRole;
}

const StoreContext = createContext<StoreContextValue | null>(null);

export const StoreContextProvider = StoreContext.Provider;

/** Текущий магазин и роль пользователя в нём — доступно везде внутри `<StoreScope/>` (§1, §9). */
export function useStoreContext(): StoreContextValue {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error('useStoreContext() must be used within a routed <StoreScope/> tree');
  return ctx;
}
